import { render } from "./AddPointVenteModal.vue?vue&type=template&id=333972d1&ts=true"
import script from "./AddPointVenteModal.vue?vue&type=script&lang=ts"
export * from "./AddPointVenteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__